import { createRouter, createWebHistory } from 'vue-router'
import { authStorage } from '../services/api'
import LoginPage from '../views/LoginPage.vue'
import RegisterPage from '../views/RegisterPage.vue'
import TabsPage from '../views/TabsPage.vue'
import LogoutPage from '../views/LogoutPage.vue'
import HomePage from '../views/HomePage.vue'
import UserCenterPage from '../views/UserCenterPage.vue'
import MoneyPage from '../views/MoneyPage.vue'
import FinancePage from '../views/FinancePage.vue'
import GamePage from '../views/GamePage.vue'
import BankPage from '../views/BankPage.vue'
import BankAddPage from '../views/BankAddPage.vue'
import BankEditPage from '../views/BankEditPage.vue'
import GameHistoryPage from '../views/GameHistoryPage.vue'
import GameBillPage from '../views/GameBillPage.vue'
import BettingPage from '../views/BettingPage.vue'
import FantanBetPage from '../views/FantanBetPage.vue'
import GameBetPage from '../views/GameBetPage.vue'
import BetRecordsPage from '../views/BetRecordsPage.vue'
import RechargeRecordsPage from '../views/RechargeRecordsPage.vue'
import CashRecordsPage from '../views/CashRecordsPage.vue'
import ProfilePage from '../views/ProfilePage.vue'
import PasswordPage from '../views/PasswordPage.vue'
import ServicePage from '../views/ServicePage.vue'
import RecommendPage from '../views/RecommendPage.vue'
import RecommendTeamPage from '../views/RecommendTeamPage.vue'
import RecommendMoneyPage from '../views/RecommendMoneyPage.vue'
import RecommendQrcodePage from '../views/RecommendQrcodePage.vue'
import LiuhePreviewPage from '../views/LiuhePreviewPage.vue'
import KlsfPreviewPage from '../views/KlsfPreviewPage.vue'
import KuaisanPreviewPage from '../views/KuaisanPreviewPage.vue'

const routes = [
  { path: '/', redirect: '/tabs' },
  { path: '/login', name: 'login', component: LoginPage },
  { path: '/register', name: 'register', component: RegisterPage },
  // 推广二维码沿用旧版公开链接；不能加 requiresAuth，否则扫码用户会被送往登录页。
  { path: '/register/recommend/:recommender', name: 'register-recommend', component: RegisterPage, props: true },
  { path: '/home', name: 'home', component: HomePage, meta: { requiresAuth: true } },
  // 旧版界面还原预览页。后端 games/ 下没有这三个游戏，页面不发起任何接口请求，
  // 也不含任何用户数据，因此不做登录校验，方便直接打开比对视觉。
  { path: '/game/preview/liuhe', name: 'preview-liuhe', component: LiuhePreviewPage },
  { path: '/game/preview/klsf', name: 'preview-klsf', component: KlsfPreviewPage },
  { path: '/game/preview/kuaisan', name: 'preview-kuaisan', component: KuaisanPreviewPage },
  // 旧版「游戏账单」的路由就是 /game/bill（chunk 23），必须排在 /game/:game 之前
  { path: '/game/bill', name: 'game-bill', component: GameBillPage, meta: { requiresAuth: true } },
  { path: '/game/:game/bet', name: 'bet', component: GameBetPage, meta: { requiresAuth: true } },
  { path: '/game/:game/history', name: 'game-history', component: GameHistoryPage, meta: { requiresAuth: true } },
  // 旧版大厅点选游戏后直接进入下注台；保留此重定向以兼容已有的 /game/:id 链接。
  { path: '/game/:game', redirect: (to) => `/game/${to.params.game}/bet` },
  { path: '/game', name: 'game', component: GamePage, meta: { requiresAuth: true } },
  { path: '/tabs/:tab?', name: 'tabs', redirect: '/home', meta: { requiresAuth: true } },
  { path: '/user/money/:type?', name: 'money', component: MoneyPage, meta: { requiresAuth: true } },
  { path: '/user/finance', name: 'finance', component: FinancePage, meta: { requiresAuth: true } },
  // 旧版 chunk 35 的路由表是 { '': app-bank, 'add': app-add, 'edit/:id': app-edit }，
  // 挂在 /user/bank 下面，这里逐条对应。注意 add / edit 必须排在动态段之前。
  { path: '/user/bank/add', name: 'bank-add', component: BankAddPage, meta: { requiresAuth: true } },
  { path: '/user/bank/edit/:id', name: 'bank-edit', component: BankEditPage, meta: { requiresAuth: true } },
  { path: '/user/bank', name: 'bank', component: BankPage, meta: { requiresAuth: true } },
  { path: '/user/bets', name: 'bets', component: BetRecordsPage, meta: { requiresAuth: true } },
  // 旧版充值记录（chunk 22 的 app-recharge）和提现记录（chunk 20 的 app-cash）
  // 是两个独立组件，字段名和状态取值都不一样，所以这里也拆成两个页面。
  { path: '/user/recharge', name: 'recharge-records', component: RechargeRecordsPage, meta: { requiresAuth: true } },
  { path: '/user/cash', name: 'cash-records', component: CashRecordsPage, meta: { requiresAuth: true } },
  { path: '/user/profile/edit', name: 'profile-edit', component: ProfilePage, meta: { requiresAuth: true } },
  { path: '/user/profile', name: 'profile', component: UserCenterPage, meta: { requiresAuth: true } },
  { path: '/user/password', name: 'password', component: PasswordPage, meta: { requiresAuth: true } },
  { path: '/user/service', name: 'service', component: ServicePage, meta: { requiresAuth: true } },
  // 旧版推广模块（chunk 12）的路由表是 { '': app-recommend, 'qrcode': app-qrcode,
  // 'team': app-team, 'money': app-money }，挂在 /tabs/recommend 下面。
  // 子路径要排在 /user/recommend 之前。
  { path: '/user/recommend/team', name: 'recommend-team', component: RecommendTeamPage, meta: { requiresAuth: true } },
  { path: '/user/recommend/money', name: 'recommend-money', component: RecommendMoneyPage, meta: { requiresAuth: true } },
  { path: '/user/recommend/qrcode', name: 'recommend-qrcode', component: RecommendQrcodePage, meta: { requiresAuth: true } },
  { path: '/user/recommend', name: 'recommend', component: RecommendPage, meta: { requiresAuth: true } },
  { path: '/user/:section?/:subsection?/:id?', name: 'user', component: UserCenterPage, meta: { requiresAuth: true } },
  { path: '/logout', name: 'logout', component: LogoutPage, meta: { requiresAuth: true } },
  { path: '/:pathMatch(.*)*', redirect: '/tabs' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  if (to.meta.requiresAuth && !authStorage.getToken()) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.name === 'login' && authStorage.getToken()) return { name: 'tabs' }
})

export default router
